/**
 * High level router.
 *
 * Note: It's recommended to compose related routes in internal router
 * components (e.g: `src/app/modules/Auth/pages/AuthPage`, `src/app/BasePage`).
 */

import {FC} from 'react'
import {Routes, Route, BrowserRouter, Navigate} from 'react-router-dom'
import {PrivateRoutes} from './PrivateRoutes'
import {ErrorsPage} from '../modules/errors/ErrorsPage'
import {Logout, AuthPage, useAuth} from '../modules/auth'
import {App} from '../App'
import {Subscription} from '../modules/stripe/Subscription'
import {ManageYourSubscription} from '../modules/stripe/ManageYourSubscription'
import {ReactivateSubscription} from '../modules/stripe/ReactivateSubscription'

/**
 * Base URL of the website.
 *
 * @see https://facebook.github.io/create-react-app/docs/using-the-public-folder
 */
const {PUBLIC_URL} = process.env

const AppRoutes: FC = () => {
  const {currentUser} = useAuth()

  console.log(currentUser);
  return (
    <BrowserRouter basename={PUBLIC_URL}>
      <Routes>
        <Route element={<App />}>
          <Route path='error/*' element={<ErrorsPage />} />
          <Route path='logout' element={<Logout />} />
          {(() => {
            if (currentUser) {
              if (
                currentUser.subscription == 'Activo' ||
                currentUser.subscription == 'Prueba' ||
                currentUser.subscription == 'Sistema' ||
                currentUser.subscription == 'Demo' ||
                currentUser.subscription == 'Promocion'
              ) {
                return (
                  <>
                    <Route path='/*' element={<PrivateRoutes />} />
                    <Route path='suscripcion/*' element={<Subscription />} />
                    <Route index element={<Navigate to='/homepage' />} />
                  </>
                )
              } else if (currentUser.subscription == 'Pago fallido') {
                return (
                  <>
                    <Route path='manageYourSubscription/*' element={<ManageYourSubscription />} />
                    <Route path='*' element={<Navigate to='/manageYourSubscription' />} />
                  </>
                )
              } else if (currentUser.subscription == 'Cancelado') {
                return (
                  <>
                     <Route path='suscripcion/*' element={<Subscription />} />
                     <Route path='*' element={<Navigate to='/suscripcion/reactivate-subscription' />} />
                  </>
                )
              } else {
                return (
                  <>
                    <Route path='suscripcion/*' element={<Subscription />} />
                    <Route path='*' element={<Navigate to='/suscripcion' />} />
                  </>
                )
              }
            } else {
              return (
                <>
                  <Route path='auth/*' element={<AuthPage />} />
                  <Route path='*' element={<Navigate to='/auth' />} />
                </>
              )
            }
          })()}
          {/* {currentUser ? (
            <>
              <Route path='/*' element={<PrivateRoutes />} />
              <Route index element={<Navigate to='/homepage' />} />
            </>
          ) : (
            <>
              <Route path='auth/*' element={<AuthPage />} />
              <Route path='*' element={<Navigate to='/auth' />} />
            </>
          )} */}
        </Route>
      </Routes>
    </BrowserRouter>
  )
}

export {AppRoutes}
